<template>
  <jr-select
    class="request-reason-select"
    :options="types"
    :modelValue="modelValue"
    valueKey="code"
    labelKey="name"
    :popperAppendToBody="popperAppendToBody"
    @update:modelValue="update($event)"
    :disabled="disabled"
    :size="size"
    :isEdit="isEdit"
  />
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import JrSelect from '@/components/jr-parts/JrSelect.vue'
import { RequestReasonTypes } from '@/constants/enums'

interface RequestReasonType {
  code: number
  name: string
}

export default defineComponent({
  name: 'RequestReasonTypeSelect',
  components: {
    JrSelect,
  },
  emits: ['update:modelValue'],
  props: {
    modelValue: {
      type: Number,
      required: false,
      default: null,
    },
    blank: {
      type: Boolean,
      required: false,
      default: true,
    },
    popperAppendToBody: {
      type: Boolean,
      required: false,
      default: true,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    size: {
      type: String,
      required: false,
      default: 'medium',
    },
    isEdit: {
      type: Boolean,
      required: false,
      default: true,
    },
    nullable: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  setup(props, context) {
    const types: RequestReasonType[] = []

    if (props.blank) {
      // 空白の選択肢を付与する
      types.push({ code: -1, name: ' ' } as const)
    }

    // 申請理由一覧の取得・保持
    types.push(...Object.values(RequestReasonTypes).map((reasonType) => reasonType))

    return {
      types,
      update: (value: number) => {
        if (props.nullable && value === -1) {
          context.emit('update:modelValue', null)
        } else {
          // 選択したvalueを返す
          context.emit('update:modelValue', value)
        }
      },
    }
  },
})
</script>
